export default __webpack_public_path__ + "static/media/award.58447e7d.webp";